var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 26,
    height: 22.75,
    rx: 10.5625,
    fill: "#E8EDF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4084 7.07106C15.183 7.07106 15.8168 6.43731 15.8168 5.66273C15.8168 4.88814 15.183 4.25439 14.4084 4.25439C13.6339 4.25439 13.0001 4.88814 13.0001 5.66273C13.0001 6.43731 13.6339 7.07106 14.4084 7.07106ZM11.803 9.46523L10.0004 18.556C9.90882 18.9856 10.2468 19.394 10.6904 19.394H10.7468C11.0777 19.394 11.3594 19.1686 11.4369 18.8447L12.5776 13.7606L14.0564 15.169V18.6898C14.0564 19.0771 14.3732 19.394 14.7605 19.394C15.1478 19.394 15.4647 19.0771 15.4647 18.6898V14.7183C15.4647 14.331 15.3098 13.9649 15.0281 13.6973L13.9859 12.7044L14.4084 10.5919C15.2019 11.4991 16.2883 12.0996 17.4786 12.2889C17.9011 12.3523 18.2814 12.0143 18.2814 11.5848C18.2814 11.2397 18.0279 10.951 17.6828 10.8947C16.6125 10.7186 15.7252 10.0849 15.2534 9.25398L14.5493 8.12731C14.3591 7.82322 14.0669 7.59673 13.725 7.48836C13.3832 7.37998 13.0139 7.3968 12.6832 7.53581L9.98628 8.67656C9.73117 8.7856 9.51373 8.96722 9.36099 9.19883C9.20826 9.43044 9.12696 9.70183 9.1272 9.97927V11.6481C9.1272 12.0354 9.44407 12.3523 9.83136 12.3523C10.2187 12.3523 10.5355 12.0354 10.5355 11.6481V9.95814L11.803 9.46523Z",
    fill: "#1746C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoam);
export default __webpack_public_path__ + "static/media/roam.71eaabb4c8e47d9720092526dec5a2a0.svg";
export { ForwardRef as ReactComponent };